<template src="./list.html"></template>

<script>
import NewsService from 'Services/NewsService';
import Pagination from 'Components/pagination/Pagination.vue';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      arrnews: [],

      // pagination
      currentPage: 1,
      from: 0,
      to: 0,
      total: 0,
      perPage: 12,
      lastPage: 1,
      isLoading: true,
      i18n: 2,
    };
  },

  created() {
    this.listNews();
  },

  methods: {
    convertHTML(value) {
      if (value) {
        if (value.length < 100) {
          return `${value.replace(/(<([^>]+)>)/g, '')}`;
        }
        return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 100)}...`;
      }

      return '';
    },
    listNews() {
      this.isLoading = true;
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const params = {
        i18n: this.i18n,
        page: this.currentPage,
        limit: this.perPage,
      };
      NewsService.list(params)
        .then((response) => {
          this.arrnews = response.data.data;
          this.from = response.data.from;
          this.to = response.data.to;
          this.total = response.data.total;
          this.lastPage = response.data.last_page;
        })
        .catch(() => {});
    },

    onPageChange(page) {
      this.currentPage = page;
      this.listNews();
    },
  },
};
</script>
